module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/design-tile-images/design-tile-02-319b8e2e06a706e2b4d1538103b0f58c.jpg";